import {
  Container,
  BackButton,
  Title,
  Section,
  LeaderboardItem,
  LeaderboardName,
  EarningContainer,
  Earning,
  TitleContainer,
  Row,
  PopupContainer,
  PopupText,
  PopupTitle,
  // PaginationButton,
  // ChevronIcon,
  // PageButton,
  // PagesContainer,
  // PaginationContainer,
  // Ellipsis,
  EmptyContainer,
  EmptyContent,
  EmptyTitleContainer,
  EmptyTitle,
  EmptySubtitle,
  ReferralLinkContainer,
  ReferralLink,
  CopyButton,
  LightText,
  DateLabel,
  DateLabelContainer,
  DateLabelRow,
  Chevron,
  SectionContainer,
  LeaderboardContainer,
} from "./ReferralEarningsPage.styles";

import Button from "../../components/utils/Button/Button";
import MainContainer from "../../components/MainContainer";
import { useNavigate } from "react-router-dom";

import { ReactComponent as StarSvg } from "../../assets/icons/star.svg";
import { ReactComponent as InfoSvg } from "../../assets/icons/info.svg";
import { ReactComponent as ChevronSvg } from "../../assets/icons/chevronLeft.svg";

import { ReactComponent as LinkSvg } from "../../assets/icons/link.svg";
import { ReactComponent as CopySvg } from "../../assets/icons/copy.svg";
import { ReactComponent as SuccessSvg } from "../../assets/icons/success.svg";

import ReferralModal from "../../components/ReferralModal/ReferralModal";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getReferralUsers } from "../../store/slices/user/asyncThunk";
import {
  selectGetReferralUsersPending,
  selectReferralEarnings,
  selectUser,
} from "../../store/slices/user/slice";
import { toast } from "sonner";
import { selectLoggedIn } from "../../store/slices/auth/slice";
import { getMonthName, priceFormatter } from "../../utils/utils";
import Loader from "../../components/utils/Loader/Loader";

const ReferralEarningsPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isOpenModal, setIsOpenModal] = useState(false);
  const [openSections, setOpenSections] = useState({});
  const [showPopup, setShowPopup] = useState(false);
  const popupRef = useRef(null);
  const {
    data,
    // total,
    // perPage,
    // page: currentPage,
  } = useSelector(selectReferralEarnings);

  const [copySuccess, setCopySuccess] = useState(false);
  const user = useSelector(selectUser);
  const referralLink = user?.affiliateLink;
  const isLoggedIn = useSelector(selectLoggedIn);

  const isLoading = useSelector(selectGetReferralUsersPending);

  // const totalPages = Math.ceil(total / perPage);

  const toggleSection = (monthKey) => {
    setOpenSections((prev) => ({
      ...prev,
      [monthKey]: !prev[monthKey],
    }));
  };

  // const onPageChange = (page) => {
  //   dispatch(getReferralUsers(page))
  //     .unwrap()
  //     .then(() => {})
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // };

  const handleBack = () => {
    navigate("/");
    setTimeout(() => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "instant",
      });
    }, 300);
  };

  useEffect(() => {
    if (isLoggedIn) {
      dispatch(getReferralUsers());
    }
  }, [dispatch, isLoggedIn]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        if (showPopup) {
          setShowPopup(false);
        }
      }
    };

    // Dodaj event listener samo ako je search otvoren
    if (showPopup) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    // Cleanup
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showPopup]);

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(referralLink);
      setCopySuccess(true);
      toast.success("Referral link copied to clipboard!");
      setTimeout(() => setCopySuccess(false), 2000);
    } catch (err) {
      console.error("Failed to copy link:", err);
      toast.error("Failed to copy link. Please try again.");
    }
  };

  const handleShare = async () => {
    const shareData = {
      title: "Join Playbun - NSFW AI Video Generation",
      text: "Create amazing NSFW AI videos with Playbun! Use my referral link to get started.",
      url: referralLink,
    };

    try {
      // Check if Web Share API is supported (mainly on mobile)
      if (navigator.share) {
        await navigator.share(shareData);
        toast.success("Invite shared successfully!");
      } else {
        // Fallback: Copy to clipboard if Web Share API is not supported
        await navigator.clipboard.writeText(
          `${shareData.text} ${shareData.url}`,
        );
        toast.success("Invite message copied to clipboard!");
      }
    } catch (err) {
      if (err.name !== "AbortError") {
        // User didn't cancel the share
        console.error("Error sharing:", err);
        toast.error("Failed to share invite. Please try again.");
      }
    }
  };

  if (!user) {
    return null;
  }

  return (
    <MainContainer>
      <Container>
        <BackButton onClick={handleBack}>
          <ChevronSvg />
          Back
        </BackButton>
        <Title>Affiliate</Title>

        {isLoading ? (
          <Loader text="Loading earnings" />
        ) : (
          <>
            {data && data.length > 0 ? (
              <>
                <TitleContainer>
                  <Row>
                    <Title>Referral Earnings</Title>
                    <InfoSvg
                      style={{
                        pointerEvents: showPopup ? "none" : "all",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        setShowPopup(true);
                      }}
                    />
                    <PopupContainer ref={popupRef} $isVisible={showPopup}>
                      <PopupTitle>Earn from Your Network!</PopupTitle>
                      <PopupText>
                        Invite users to Playbun and receive 30% of their
                        lifetime spend.
                      </PopupText>
                    </PopupContainer>
                  </Row>
                  <Button
                    title={"Invite Friends"}
                    onClick={() => {
                      setIsOpenModal(true);
                    }}
                  />
                </TitleContainer>
                <SectionContainer>
                  {data?.map((month, sectionIndex) => {
                    const monthKey = `${month?.month}-${sectionIndex}`;
                    const isOpen = openSections[monthKey];
                    return (
                      <Section key={monthKey} $open={isOpen}>
                        <DateLabelContainer
                          onClick={() => toggleSection(monthKey)}
                          $open={isOpen}
                        >
                          <DateLabel>{getMonthName(month?.month)}</DateLabel>
                          <DateLabelRow>
                            <EarningContainer>
                              <StarSvg />
                              <Earning>
                                {priceFormatter(month?.totalCredits)}
                              </Earning>
                            </EarningContainer>
                            <Chevron className="chevron" />
                          </DateLabelRow>
                        </DateLabelContainer>
                        <LeaderboardContainer
                          $open={isOpen}
                          $itemCount={month?.logs?.length}
                        >
                          {month?.logs?.map((log, index) => (
                            <LeaderboardItem
                              key={`${monthKey}-${index}`}
                              $open={isOpen}
                            >
                              <LeaderboardName>
                                @{log?.affiliateUser?.username}
                              </LeaderboardName>
                              <EarningContainer>
                                <StarSvg />
                                <Earning>
                                  {priceFormatter(log?.numOfCredits)}
                                </Earning>
                              </EarningContainer>
                            </LeaderboardItem>
                          ))}
                        </LeaderboardContainer>
                      </Section>
                    );
                  })}
                </SectionContainer>
              </>
            ) : (
              <EmptyContainer>
                <EmptyContent>
                  <LinkSvg />
                  <EmptyTitleContainer>
                    <EmptyTitle>Earn from Your Network!</EmptyTitle>
                    <EmptySubtitle>
                      Invite users to Playbun and receive 30% of their lifetime
                      spend.
                    </EmptySubtitle>
                  </EmptyTitleContainer>

                  <ReferralLinkContainer>
                    <ReferralLink>
                      <span>{referralLink?.replace("https://www.", "")}</span>
                    </ReferralLink>
                    <CopyButton onClick={handleCopyLink} $success={copySuccess}>
                      {copySuccess ? <SuccessSvg /> : <CopySvg />}
                    </CopyButton>
                  </ReferralLinkContainer>
                  <LightText>or</LightText>
                  <Button onClick={handleShare} title={"Invite Friends"} />
                </EmptyContent>
              </EmptyContainer>
            )}
          </>
        )}
      </Container>

      <ReferralModal
        isOpen={isOpenModal}
        onClose={() => setIsOpenModal(false)}
      />
    </MainContainer>
  );
};

export default ReferralEarningsPage;
